import { Toaster as Sonner, toast } from "sonner"

const Toaster = (props) => {
  return (
    <Sonner
      theme="light"
      className="toaster group"
      toastOptions={{
        classNames: {
          toast: "group toast group-[.toaster]:bg-white group-[.toaster]:text-[#2B2B2B] group-[.toaster]:border-[#2B2B2B]/10 group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-[#5a5a5a]",
          actionButton: "group-[.toast]:bg-[#0B3D2E] group-[.toast]:text-white",
          cancelButton: "group-[.toast]:bg-[#F5F3EF] group-[.toast]:text-[#2B2B2B]",
        },
      }}
      {...props}
    />
  );
};

export { Toaster, toast }
